import { fork } from 'redux-saga/effects';
import addPrimaryToCartWatcher from './sagas/AddPrimaryToCartSaga';
import addToCartEventWatcher from './sagas/AddToCartEventSaga';
import addToCartWatcher from './sagas/AddToCartSaga';
import removeFromCartWatcher from './sagas/RemoveFromCartSaga';
import sendEventWatcher from './sagas/SendEventSaga';

export default function* initSaga() {
  yield [
    fork(sendEventWatcher),
    fork(addToCartWatcher),
    fork(addToCartEventWatcher),
    fork(addPrimaryToCartWatcher),
    fork(removeFromCartWatcher),
  ];
}
